/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CodeLanguage } from './CodeLanguage';
import {
    CodeLanguageFromJSON,
    CodeLanguageFromJSONTyped,
    CodeLanguageToJSON,
    CodeLanguageToJSONTyped,
} from './CodeLanguage';
import type { ProblemType } from './ProblemType';
import {
    ProblemTypeFromJSON,
    ProblemTypeFromJSONTyped,
    ProblemTypeToJSON,
    ProblemTypeToJSONTyped,
} from './ProblemType';

/**
 * 
 * @export
 * @interface ProblemCreate
 */
export interface ProblemCreate {
    /**
     * 
     * @type {string}
     * @memberof ProblemCreate
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ProblemCreate
     */
    ordinal?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemCreate
     */
    statement: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemCreate
     */
    solution_code: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemCreate
     */
    extra_code?: string;
    /**
     * 
     * @type {number}
     * @memberof ProblemCreate
     */
    points: number;
    /**
     * 
     * @type {number}
     * @memberof ProblemCreate
     */
    time_limit?: number;
    /**
     * 
     * @type {number}
     * @memberof ProblemCreate
     */
    complexity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProblemCreate
     */
    is_public?: boolean;
    /**
     * 
     * @type {ProblemType}
     * @memberof ProblemCreate
     */
    problem_type: ProblemType;
    /**
     * 
     * @type {CodeLanguage}
     * @memberof ProblemCreate
     */
    solution_language: CodeLanguage;
}



/**
 * Check if a given object implements the ProblemCreate interface.
 */
export function instanceOfProblemCreate(value: object): value is ProblemCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('statement' in value) || value['statement'] === undefined) return false;
    if (!('solution_code' in value) || value['solution_code'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('problem_type' in value) || value['problem_type'] === undefined) return false;
    if (!('solution_language' in value) || value['solution_language'] === undefined) return false;
    return true;
}

export function ProblemCreateFromJSON(json: any): ProblemCreate {
    return ProblemCreateFromJSONTyped(json, false);
}

export function ProblemCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProblemCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'ordinal': json['ordinal'] == null ? undefined : json['ordinal'],
        'statement': json['statement'],
        'solution_code': json['solution_code'],
        'extra_code': json['extra_code'] == null ? undefined : json['extra_code'],
        'points': json['points'],
        'time_limit': json['time_limit'] == null ? undefined : json['time_limit'],
        'complexity': json['complexity'] == null ? undefined : json['complexity'],
        'is_public': json['is_public'] == null ? undefined : json['is_public'],
        'problem_type': ProblemTypeFromJSON(json['problem_type']),
        'solution_language': CodeLanguageFromJSON(json['solution_language']),
    };
}

export function ProblemCreateToJSON(json: any): ProblemCreate {
    return ProblemCreateToJSONTyped(json, false);
}

export function ProblemCreateToJSONTyped(value?: ProblemCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'ordinal': value['ordinal'],
        'statement': value['statement'],
        'solution_code': value['solution_code'],
        'extra_code': value['extra_code'],
        'points': value['points'],
        'time_limit': value['time_limit'],
        'complexity': value['complexity'],
        'is_public': value['is_public'],
        'problem_type': ProblemTypeToJSON(value['problem_type']),
        'solution_language': CodeLanguageToJSON(value['solution_language']),
    };
}

